<template>                      
    <div class="np-tabs np-mb-2">
        <button
          v-for="(tab, index) in tabs"
          :key="tab.id"
          :id="tab.id"
          :class="['np-tab', { active: activeTab === tab.id }]"
          @click="selectTab(tab.id)"
        >
            <svg v-if="tab.icon" class="icon"><use :xlink:href="tab.icon"></use></svg>
            <span>{{ tab.title }}</span>
            <span v-if="tab.value" class="np-badge-s np-inactive np-ml-1">{{ tab.value }}</span>
        </button>
    </div>

    <div class="np-tabs-content">
        <slot :key="activeTab"></slot>
    </div>

  </template>
  
  <script>
  import { computed } from 'vue'

  export default {
    props: {
      modelValue: {
        type: String,
        default: null 
      }
    },
    data() {
      return {
        tabs: [],
        localActiveTab: null
      }
    },
    computed: {
      activeTab: {
        get() {
          return this.localActiveTab || this.modelValue
        },
        set(value) {
          this.localActiveTab = value
          this.$emit("update:modelValue", value)
        }
      }
    },
    mounted() {
      this.initTabs();
      if (this.tabs.length > 0) {
        this.activeTab = this.modelValue || this.tabs[0].id
      }
    },
    methods: {
      initTabs() {
        this.tabs = this.$slots.default()
          .filter((node) => node.type.name === "Tab")
          .map((node) => ({
            id: node.props.id,
            title: node.props.title,
            value: node.props.value,
            icon: node.props.icon
          }))
      },
      selectTab(id) {
        this.activeTab = id
        console.log(this.activeTab)        
      }
    },
    provide() {
      return {
        activeTab: computed( () => this.activeTab )
      }
    }
  }
  </script>
  
  <style scoped>
  </style>